import { Instagram, Youtube, Mail } from "lucide-react";
import { TEST_IDS } from "@/constants/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TEST_IDS.footer}
      className="bg-[#FDFCFB] border-t border-[#E5E1DA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-serif-display text-[clamp(48px,7vw,110px)] leading-[0.9] tracking-tight text-[#1C1C1A]">
              Church <em className="text-[#E07A5F] not-italic">Clips</em>
              <br />
              <span className="italic">Studio.</span>
            </div>
            <p className="mt-6 max-w-md text-[15px] text-[#1C1C1A]/70">
              A small studio helping small churches share the moments that
              matter — one Sunday at a time.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Sitemap</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href="#work" className="link-underline">Selected work</a></li>
              <li><a href="#process" className="link-underline">Our process</a></li>
              <li><a href="#pricing" className="link-underline">Pricing</a></li>
              <li><a href="#faq" className="link-underline">FAQ</a></li>
              <li><a href="#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Elsewhere</div>
            <ul className="space-y-3 text-[15px]">
              <li>
                <a href="mailto:hello@churchclipsstudio.com" className="link-underline inline-flex items-center gap-2">
                  <Mail size={14} /> hello@churchclipsstudio.com
                </a>
              </li>
              <li>
                <a href="#" className="link-underline inline-flex items-center gap-2">
                  <Instagram size={14} /> Instagram
                </a>
              </li>
              <li>
                <a href="#" className="link-underline inline-flex items-center gap-2">
                  <Youtube size={14} /> YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-[#E5E1DA] pt-8">
          <div className="text-[12px] tracking-widest uppercase text-[#787672]">
            © {year} Church Clips Studio · Made with a lot of coffee.
          </div>
          <div className="text-[12px] tracking-widest uppercase text-[#787672]">
            Nashville · Remote · Everywhere
          </div>
        </div>
      </div>
    </footer>
  );
}
